<div [formGroup]="checkboxes">
  <bit-form-control>
    <input
      type="checkbox"
      bitCheckbox
      [formControlName]="parentId"
      [indeterminate]="parentIndeterminate"
    />
    <bit-label>{{ parentId | i18n }}</bit-label>
  </bit-form-control>
  <div class="tw-ml-4">
    @for (c of checkboxes.controls | keyvalue; track key($index, c)) {
      @if (c.key != parentId) {
        <div>
          <bit-form-control>
            <input type="checkbox" bitCheckbox [formControl]="c.value" (change)="onChildCheck()" />
            <bit-label>{{ c.key | i18n }}</bit-label>
          </bit-form-control>
        </div>
      }
    }
  </div>
</div>
